/* eslint-disable */
import moment from 'moment';
import _ from 'lodash';
import { getUnitConvertedQuantity } from '../../../Helpers';
import { notificationServices } from '@/Services';
import { loadState, saveState, clearState } from '@/Helpers/persistenceUtils';

export const getStorageKey = (orderTypeId) =>
	`unsaved_purchase_order_${orderTypeId}`;

const initialState = {
	vendor: {},
	vendorLocation: {},
	vendorLocationId: null,
	fromStore: {},
	deliverTo: {},
	fromProcess: null,
	toProcess: null,
	store: null,
	manualRateUpdatedVariantIds: [],
	selectedProcess: {},
	purchaseOrderId: '',
	date: new Date(),
	expectedDeliveryDate: new Date(
		new Date().setDate(new Date().getDate() + 1)
	),
	paymentTerm: '',
	poItems: [],
	poItemsObject: {},
	deliveryCharges: 0,
	packagingCharges: 0,
	editedFields: [],
	selectedShift: null,
	rejectionReason: '',
	transferOrderType: 'DISPATCH',
	workOrderType: 'PRODUCTION PLAN',
	additionalCharges: [
		{
			type: 'Additional Charges',
			taxPercentage: 18,
			price: 0,
		},
	],
	externalOrderRef: '',
	orderTypeInternal: 'PO',
	internalProcess: null,
	internalShift: null,
	workersGrade: [
		{ label: 'Grade A', value: null, key: 'gradeA' },
		{ label: 'Grade B', value: null, key: 'gradeB' },
		{ label: 'Grade C', value: null, key: 'gradeC' },
	],
	priorityOrder: false,
	// ...loadState(getStorageKey(1)),
};

export const createOrderReducer = (orderTypeId) => {
	// if (!orderTypeId) {
	//     throw new Error("orderTypeId is required");
	// }

	return (state, action) => {
		return reducer(state, {
			...action,
			orderTypeId: orderTypeId,
		});
	};
};

const reducer = (state, action) => {
	const storageKey = getStorageKey(action.orderTypeId);
	let newState;

	switch (action.type) {
		case 'SET_VENDOR':
			newState = {
				...state,
				vendor: action.payload === undefined ? null : action.payload,
			};
			break;
		case 'SET_FROM_STORE':
		case 'SET_FROM_STORE_INIT':
			newState = {
				...state,
				fromStore: action.payload,
			};
			break;
		case 'SET_DELIVER_TO':
		case 'SET_DELIVER_TO_INIT':
			newState = {
				...state,
				deliverTo: action.payload,
				selectedProcess: {},
			};
			break;
		case 'SET_PURCHASE_ORDER':
			newState = {
				...state,
				purchaseOrderId: action.payload,
			};
			break;
		case 'SET_DATE':
			newState = {
				...state,
				date: action.payload,
			};
			break;
		case 'SET_MANUAL_RATE_UPDATED':
			newState = {
				...state,
				manualRateUpdatedVariantIds: Array.from(
					new Set([
						...state?.manualRateUpdatedVariantIds,
						action.payload,
					])
				),
			};
			break;
		case 'SET_EXPECTED_DELIVERY_DATE':
			newState = {
				...state,
				expectedDeliveryDate: action.payload,
			};
			break;
		case 'SET_PAYMENT_TERM':
			newState = {
				...state,
				paymentTerm: action.payload,
			};
			break;
		case 'SET_PO_ITEMS':
			newState = {
				...state,
				poItems: action.payload,
			};
			break;
		case 'SET_PO_ITEMS_OBJECT':
			newState = {
				...state,
				poItemsObject: action.payload,
			};
			break;
		case 'SET_SHIFT':
			newState = {
				...state,
				selectedShift: action.payload,
			};
			break;
		case 'SET_PACKAGING_CHARGES':
			newState = {
				...state,
				packagingCharges: action.payload,
			};
			break;
		case 'SET_DELIVERY_CHARGES':
			newState = {
				...state,
				deliveryCharges: action.payload,
			};
			break;
		case 'SET_PROCESS':
			newState = {
				...state,
				selectedProcess: action.payload,
			};
			break;
		case 'SET_FROM_PROCESS':
			newState = {
				...state,
				fromProcess: action.payload,
			};
			break;
		case 'SET_TO_PROCESS':
			newState = {
				...state,
				toProcess: action.payload,
			};
			break;
		case 'SET_STORE':
			newState = {
				...state,
				store: action.payload,
			};
			break;
		case 'SET_VENDOR_LOCATION':
			newState = {
				...state,
				vendorLocation: action.payload,
			};
			break;
		case 'SET_TRANSFER_ORDER_TYPE':
			newState = {
				...state,
				transferOrderType: action.payload,
				selectedShift: null,
			};
			break;
		case 'SET_WORK_ORDER_TYPE':
			newState = {
				...state,
				workOrderType: action.payload,
			};
			break;
		case 'SET_VALUE':
		case 'SET_VALUE_INIT':
			newState = {
				...state,
				...action.payload,
			};
			break;
		case 'SET_EXTERNAL_ORDER_REF':
			newState = {
				...state,
				externalOrderRef: action.payload,
			};
			break;
		case 'INIT':
			newState = {
				...initialState,
			};
			break;
		case 'SET_ORDER_TYPE_INTERNAL':
			newState = {
				...state,
				orderTypeInternal: action.payload,
			};
			break;
		case 'SET_INTERNAL_PROCESS':
			newState = {
				...state,
				internalProcess: action.payload,
			};
			break;
		case 'SET_INTERNAL_SHIFT':
			newState = {
				...state,
				internalShift: action.payload,
			};
			break;
		case 'SET_WORKERS_GRADE':
			newState = {
				...state,
				workersGrade: action.payload,
			};
			break;
		case 'SET_PRIORITY_ORDER':
			newState = {
				...state,
				priorityOrder: action.payload,
			};
			break;
		case 'RESTORE_UNSAVED_DATA':
			const persistedState = loadState(storageKey);

			if (persistedState) {
				notificationServices?.generateNotification({
					type: 'info',
					message: 'Unsaved form data has been restored',
				});

				newState = {
					...initialState,
					...persistedState,
					date: persistedState.date
						? new Date(persistedState.date)
						: initialState.date,
					expectedDeliveryDate: persistedState.expectedDeliveryDate
						? new Date(persistedState.expectedDeliveryDate)
						: initialState.expectedDeliveryDate,
				};
			}
			break;

		case 'SAVE_SUCCESS':
		case 'CLEAR_STORAGE':
			clearState(storageKey);
			return initialState;

		default:
			return state;
	}

	// Only persist if we got a new state and it's meaningful
	if (
		newState &&
		action.type !== 'SAVE_SUCCESS' &&
		action.type !== 'INIT' &&
		action.type !== 'RESTORE_UNSAVED_DATA' &&
		action.type !== 'SET_VALUE_INIT' &&
		action.type !== 'SET_DELIVER_TO_INIT' &&
		action.type !== 'SET_FROM_STORE_INIT' &&
		action.type !== 'SET_PURCHASE_ORDER'
		// &&
		// isMeaningfulDraft(newState)
	) {
		console.table('Persisting state changes:', {
			action: action.type,
			previousState: state,
			changes: action.payload,
			newState,
		});
		saveState(storageKey, newState);
	}

	console.log('action previouseState changes newState:', {
		action: action.type,
		previousState: state,
		changes: action.payload,
		newState,
	});

	return newState || state;
};

// const getTotalPrice = (price, tax, quantity, unit) => {
const getTotalPrice = (subTotal, totalTax) => {
	// if (unit === 'gram') {
	// return (
	// ((price * tax) / 100) * (quantity / 1000) +
	// price * (quantity / 1000)
	// );
	// }
	// if (unit === 'oz') {
	// return (
	// ((price * tax) / 100) * (quantity / 16) +
	// price * (quantity / 16)
	// );
	// }
	// return ((price * tax) / 100) * quantity + price * quantity;
	return subTotal + totalTax;
};
const getTotalDiscount = (price, discountPercentage, quantity, unit) => {
	const gramDiscountPrice =
		(price * (quantity / 1000) * discountPercentage) / 100;
	const ozDiscountPrice =
		price * (quantity / 16) * (discountPercentage / 100);
	const countDiscountPrice = (price * quantity * discountPercentage) / 100;
	if (unit === 'gram' || unit === 'g' || unit === 'ml') {
		return gramDiscountPrice;
	}
	if (unit === 'oz') {
		return ozDiscountPrice;
	}
	return countDiscountPrice;
};
const getSubTotal = (price, discountPercentage, quantity, unit) => {
	const gramDiscountPrice =
		price * (quantity / 1000) * (discountPercentage / 100);
	const ozDiscountPrice =
		price * (quantity / 16) * (discountPercentage / 100);
	const countDiscountPrice = price * quantity * (discountPercentage / 100);
	if (unit === 'gram' || unit === 'g' || unit === 'ml') {
		return price * (quantity / 1000) - gramDiscountPrice;
	}
	if (unit === 'oz') {
		return price * (quantity / 16) - ozDiscountPrice;
	}
	if (unit === 'floz') {
		return price * (quantity / 128) - ozDiscountPrice;
	}
	return price * quantity - countDiscountPrice;
};

const getTotalTax = (price, discountPercentage, tax, quantity, unit) => {
	const gramDiscountPrice =
		price * (quantity / 1000) * (discountPercentage / 100);
	const ozDiscountPrice =
		price * (quantity / 16) * (discountPercentage / 100);
	const countDiscountPrice = price * quantity * (discountPercentage / 100);
	if (unit === 'gram' || unit === 'g' || unit === 'ml') {
		return (price * (quantity / 1000) - gramDiscountPrice) * (tax / 100);
	}
	if (unit === 'oz') {
		return (price * (quantity / 16) - ozDiscountPrice) * (tax / 100);
	}
	return (price * quantity - countDiscountPrice) * (tax / 100);
};
const getCapexSerializedItem = (item, result) => {
	let reqOem = item?.oems?.find?.((oem) => oem?.isSelected);
	// Handle case where reqOem is undefined before JSON operations
	reqOem = reqOem ? JSON.parse(JSON.stringify(reqOem)) : null;
	if (reqOem) {
		delete reqOem?.isSelected;
		delete reqOem?.client;
		delete reqOem?.active;
	}

	return {
		productId: item?.productId,
		variantId: result,
		qty: Number(item?.quantity),
		price: Number(item?.selectedVariant?.price),
		description: item?.description ?? '',
		tax: Number(item?.tax),
		discountPercentage: 0.0,
		info: {
			coreSpecifications: item?.coreSpecifications,
			oem: reqOem,
		},
	};
};

const getAssetGroupedSerializedItem = (groupedObject, cartItem) => {
	const serializedItems = [];
	Object.entries(cartItem).forEach(([groupedKey, orderQty]) => {
		const groupedItem = groupedObject[groupedKey];
		const orderItem = {
			qty: orderQty,
			info: {
				refAssetId: groupedItem?.refAsset?.id,
				assetType: {
					id: groupedItem?.assetType?.id,
					name: groupedItem?.assetType?.name,
				},
				category: groupedItem?.category,
				oem: groupedItem?.oem,
				coreSpecs: groupedItem?.specsToBeShownOnGroups?.map((spec) => ({
					id: spec?.id,
					label: spec?.label,
					dataType: spec?.dataType,
					uom: spec?.uom,
					value:
						spec?.isChecked === false ? spec.newValue : spec?.value,
				})),
			},
		};
		serializedItems.push(orderItem);
	});
	return serializedItems;
};

// Serializer for order type 7 using poItems array
const getAssetPoItemsSerializedItem = (poItems) => {
	return (
		poItems?.map((item) => {
			let selectedOem = item?.oems?.find?.((oem) => oem?.isSelected);
			selectedOem = selectedOem
				? JSON.parse(JSON.stringify(selectedOem))
				: null;
			if (selectedOem) {
				delete selectedOem?.isSelected;
				delete selectedOem?.client;
				delete selectedOem?.active;
			}

			let category = null;
			if (item?.assetCategory) {
				category = {
					id: item?.assetCategory?.id,
					name: item?.assetCategory?.name,
					categoryCode: item?.assetCategory?.categoryCode,
				};
			}

			return {
				qty: Number(item?.quantity),
				price: Number(item?.selectedVariant?.price),
				info: {
					refAssetId: null,
					assetType: {
						id: item?.productId || item?.id,
						name: item?.productName,
					},
					category: category,
					oem: selectedOem,
					coreSpecs: item?.coreSpecifications?.map((spec) => ({
						id: spec?.id,
						label: spec?.label,
						dataType: spec?.dataType,
						uom: spec?.uom,
						value: spec?.value,
					})),
				},
			};
		}) ?? []
	);
};

const getServiceItemList = () => {};

const config = {
	initialState,
	reducer,
	validator: (state, orderType, processTypeList = [], shiftlist = []) => {
		let focusIndex = -1;
		const errors = [];
		const intOrderType = Number(orderType);
		// Check if vendor object is empty
		if (intOrderType == 1 && Object.keys(state.vendor)?.length === 0) {
			errors.push('Vendor is mandatory');
		}

		// Check if fromStore object is empty
		if (
			![1, 4, 5, 6, 7, 9].includes(Number(intOrderType)) &&
			Object.keys(state.fromStore).length === 0
		) {
			errors.push('From Store is mandatory');
		}

		// Check if deliverTo object is empty
		if (
			![5, 6, 8].includes(Number(intOrderType)) &&
			Object.keys(state.deliverTo).length === 0
		) {
			errors.push('Deliver To is mandatory');
		}

		// if (![5, 6].includes(intOrderType) && !state.purchaseOrderId) {
		// 	errors.push('Purchase Order ID is mandatory');
		// }

		// Check if paymentTerm is empty
		if (![5, 6, 2, 3, 7].includes(intOrderType) && !state.paymentTerm) {
			errors.push('Payment Term is mandatory');
		}
		// Check if poItems array is empty

		if (intOrderType === 7) {
			if (state.poItems.length === 0) {
				errors.push('Asset Items are mandatory');
				return [errors, focusIndex];
			}
			// // Validate OEM and core specifications like type 4
			// let oemNotProvided = false;
			// const supplierMandatoryItemWithNoValue = state?.poItems?.find(
			// 	(item, index) => {
			// 		if (!item?.oems || item?.oems?.length === 0) {
			// 			focusIndex = index;
			// 			oemNotProvided = true;
			// 			return true;
			// 		}
			// 		if (item?.oems?.length > 0) {
			// 			const isSelected = item?.oems?.some(
			// 				(thisOem) => thisOem?.isSelected
			// 			);
			// 			if (!isSelected) {
			// 				focusIndex = index;
			// 				oemNotProvided = true;
			// 				return true;
			// 			}
			// 		}
			// 		if (item?.coreSpecifications?.length === 0) {
			// 			return true;
			// 		}
			// 		return false;
			// 	}
			// );
			// if (
			// 	supplierMandatoryItemWithNoValue?.coreSpecifications?.length === 0
			// ) {
			// 	errors.push(
			// 		`There is no CoreSpecifications against this ${supplierMandatoryItemWithNoValue?.productName} at index ${focusIndex + 1}`
			// 	);
			// 	return [errors, focusIndex];
			// }
			// if (oemNotProvided) {
			// 	errors.push(
			// 		`OEM Field is mandatory for ${supplierMandatoryItemWithNoValue?.productName} at index ${focusIndex + 1}`
			// 	);
			// }
			// return [errors, focusIndex];
		}
		if (state.poItems.length === 0) {
			errors.push('PO Items are mandatory');
		}
		if (
			intOrderType === 2 &&
			state?.orderTypeInternal === 'CMS_INDENT' &&
			!state?.selectedProcess?.id
		) {
			errors.push('Delivery Location is mandatory');
		}
		if (
			intOrderType === 2 &&
			['CMS', 'CMS_INDENT'].includes(state?.orderTypeInternal) &&
			!state?.internalProcess?.id
		) {
			errors.push('Process is mandatory');
		}
		if (
			intOrderType === 2 &&
			state?.orderTypeInternal === 'CMS' &&
			state?.internalProcess?.id &&
			!state?.internalShift?.id
		) {
			errors.push('Shift is mandatory');
		}

		if (intOrderType === 6) {
			if (!state?.store?.id) {
				errors.push('Store is mandatory');
			}
			if (!state?.toProcess?.id) {
				errors.push('To process is mandatory');
			}
			if (!state?.selectedShift?.id) {
				errors.push('Shift selection is mandatory');
			}
		}

		if (intOrderType === 5) {
			if (!state?.store?.id) {
				errors.push('Store is mandatory');
			}
			if (!state?.fromProcess?.id) {
				errors.push('From process is mandatory');
			}
			if (!state?.toProcess?.id) {
				errors.push('To process is mandatory');
			}
			if (!state?.selectedShift?.id) {
				errors.push('Shift selection is mandatory');
			}
		}

		if (
			![5, 6].includes(intOrderType) &&
			state?.vendor?.id &&
			state.vendor?.vendor_locations?.length &&
			!state?.vendorLocation?.id
		) {
			errors.push('Please select vendor location');
		}

		if (intOrderType == 4) {
			let specInfo = {};
			let oemNotProvided = false;
			const supplierMandatoryItemWithNoValue = state?.poItems?.find(
				(item, index) => {
					// eslint-disable-next-line max-len
					if (!item?.oems || item?.oems?.length === 0) {
						focusIndex = index;
						oemNotProvided = true;
						return true;
					}
					if (item?.oems?.length > 0) {
						const isSelected = item?.oems?.some(
							(thisOem) => thisOem?.isSelected
						);
						if (!isSelected) {
							focusIndex = index;
							oemNotProvided = true;
							return true;
						}
					}
					// eslint-disable-next-line max-len
					if (item?.coreSpecifications.length === 0) {
						return true;
					}
					const supplierMandatoryCoreSpecification =
						item?.coreSpecifications?.find((coreSpecification) => {
							if (coreSpecification?.rfqMandatory) {
								if (
									coreSpecification?.value === '' ||
									coreSpecification?.value === undefined ||
									coreSpecification?.value === null
								) {
									specInfo = coreSpecification;
									return item;
								}
							}
							return false;
						});
					if (supplierMandatoryCoreSpecification) {
						focusIndex = index;
						return true;
					}
					return false;
				}
			);
			if (
				supplierMandatoryItemWithNoValue?.coreSpecifications?.length ==
				0
			) {
				errors.push(
					`There is no CoreSpecifications against this  ${
						supplierMandatoryItemWithNoValue?.productName
					} at index ${focusIndex + 1}`
				);
				return [errors, focusIndex];
			}
			if (oemNotProvided) {
				errors.push(
					`${
						oemNotProvided ? 'OEM' : specInfo?.label
					} Field is mandatory for ${
						supplierMandatoryItemWithNoValue?.productName
					} at index ${focusIndex + 1}`
				);
			}
			return [errors, focusIndex];
		}
		if (intOrderType == 5) {
			state?.poItems?.forEach((item) => {
				const itemMoq = item?.selectedVariant?.pieces?.split(',')?.[0];
				if (intOrderType == 3 && itemMoq) {
					if (
						item?.productInputUnit === 'kg' &&
						Number(item?.quantity) % (Number(itemMoq) / 1000) !== 0
					) {
						errors?.push(
							// eslint-disable-next-line prefer-template
							'Quantity of Item (' +
								item?.productName +
								') should be according to MOQ(' +
								Number(itemMoq) / 1000 +
								') like ' +
								(Number(itemMoq) / 1000) * 1 +
								', ' +
								(Number(itemMoq) / 1000) * 2 +
								';'
						);
					} else if (
						item?.productInputUnit === 'g' &&
						Number(item?.quantity) % Number(itemMoq) !== 0
					) {
						errors?.push(
							// eslint-disable-next-line prefer-template
							'Quantity of Item (' +
								item?.productName +
								') should be according to MOQ(' +
								itemMoq +
								') like ' +
								Number(itemMoq) * 1 +
								', ' +
								Number(itemMoq) * 2 +
								';'
						);
					}
				}
			});
		}

		return [errors, focusIndex];
	},
	deserialize: (
		state,
		orderTypeId,
		parentGroupedAssets = {},
		buyerSystemIdList = []
	) => {
		let type;
		let appOrderType;
		if (orderTypeId === 4 || orderTypeId === 7) {
			type = 'CAPEX';
		} else if (orderTypeId === 9) {
			type = 'SERVICE';
		} else if (orderTypeId === 5) {
			type = 'TRANSFER';
			appOrderType = 'FMS_TRANSFER';
		} else if (orderTypeId === 6) {
			type = 'WORK_ORDER';
			appOrderType = 'WORK_ORDER';
		} else if (orderTypeId === 2) {
			appOrderType = state?.orderTypeInternal;
		}
		const newState = {
			orderType: orderTypeId,
			date: moment(state?.date)?.format('M/D/YYYY') ?? '',
			scheduled:
				moment(state?.expectedDeliveryDate)?.format('M/D/YYYY') ?? '',
			priority: state?.priorityOrder ?? false,
			jsonData: {
				paymentTerm: state?.paymentTerm ?? '',
				additionalCharges:
					state?.additionalCharges?.map((ele) => ({
						...ele,
						taxPercentage: Number(ele?.taxPercentage ?? 0),
						price: Number(ele?.price ?? 0),
					})) ?? [],
				...(orderTypeId === 6
					? {
							workersByGrade: state?.workersGrade
								?.filter((ele) => ele?.value)
								?.map((ele) => ({
									value: ele?.value,
									key: ele?.key,
								})),
					  }
					: {}),
			},
			store: [5, 6].includes(orderTypeId)
				? state?.store?.id
				: state?.deliverTo?.id,
			toProcess: ['CMS', 'CMS_INDENT'].includes(state?.orderTypeInternal)
				? state?.internalProcess?.id
				: state?.toProcess?.id ?? null,
			fromProcess:
				state?.orderTypeInternal === 'CMS_INDENT'
					? state?.selectedProcess?.id
					: state?.fromProcess?.id ?? null,
			vendor: state?.vendor?.id === undefined ? null : state?.vendor?.id,
			shift:
				state?.orderTypeInternal === 'CMS'
					? state?.internalShift?.id
					: state?.selectedShift?.id ?? null,
			transferOrderType: state?.transferOrderType ?? '',
			manualRateUpdatedVariantIds:
				state?.manualRateUpdatedVariantIds?.length > 0
					? state?.manualRateUpdatedVariantIds
					: false,
			startTime: state?.selectedShift?.process?.[0]?.startTime ?? null,
			appOrderType,
			type,
			externalOrderRef: state?.externalOrderRef ?? '',
			workOrderType: state?.workOrderType ?? '',
			processType:
				state?.orderTypeInternal === 'CMS_INDENT'
					? null
					: state?.selectedProcess?.id,
			vendorLocationId:
				state?.vendorLocation?.id === undefined
					? null
					: state?.vendorLocation?.id,
			fromStore: [5, 6].includes(orderTypeId)
				? state?.store?.id
				: state?.fromStore?.id,
			purchaseOrderId: `${state?.purchaseOrderId}`,
			deliveryCharges:
				state?.deliveryCharges > 0 ? Number(state?.deliveryCharges) : 0,

			packagingCharges:
				state?.packagingCharges > 0
					? Number(state?.packagingCharges)
					: 0,
		};
		if (orderTypeId === 7) {
			newState.items = getAssetPoItemsSerializedItem(state?.poItems);
		} else {
			newState.items =
				state?.poItems?.map((ele) => {
					let isPackSelected =
						ele?.selectedPackSize?.id !== 'unpacked'
							? ele?.selectedPackSize?.id
							: null;
					if (isPackSelected) {
						ele.productInputUnit = 'count';
					}
					const itemQty =
						ele?.productInputUnit !== 'count'
							? Number(
									getUnitConvertedQuantity(
										Number(ele?.quantity),
										ele?.productInputUnit,
										false,
										true
									)
							  )
							: Number(ele?.quantity);
					const displayName = ele?.selectedVariant?.displayName;
					let result;
					if (displayName === 'ASSET') {
						result = -1;
					} else if (displayName === 'SERVICE') {
						result = -2;
					} else {
						result = ele?.selectedVariant?.id ?? null;
					}
					if (orderTypeId === 9) {
						result = -2;
					}
					if (
						orderTypeId === 4 &&
						(displayName === 'ASSET' ||
							displayName === 'SERVICE') &&
						ele?.coreSpecifications?.length > 0
					) {
						return getCapexSerializedItem(ele, result);
					}
					const item = {
						productId: ele?.productId ?? null,
						id: ele?.id,
						variantId: result,
						qty: !isNaN(itemQty) ? itemQty : null,
						price: Number(ele?.selectedVariant?.price ?? 0),
						description: ele?.description ?? '',
						tax: Number(ele?.tax) ?? 0,
						discountPercentage: !isNaN(
							Number(ele?.discountPercentage)
						)
							? Number(ele?.discountPercentage)
							: 0,
						existingItemId: ele?.existingItemId,
						packMappingId:
							ele?.selectedPackSize?.id !== 'unpacked'
								? ele?.selectedPackSize?.id
								: null,
					};
					if (orderTypeId === 6) {
						item.extraData = {
							...ele?.extraData,
							batchId: ele?.extraData?.batchId ?? '',
						};
					}
					if (orderTypeId === 2 && ele?.selectedPackSize?.id) {
						item.extraData = {
							...ele?.extraData,
						};
					}
					if (orderTypeId === 8) {
						item.extraData = {
							comment: ele?.comment,
							buyerSystemId:
								buyerSystemIdList?.find(
									(item) =>
										item?.variantId === ele?.id &&
										item?.active
								)?.vendorSystemVariantId ?? '',
						};
					}
					// Only add assetTypeId when orderTypeId is 9
					if (orderTypeId === 9) {
						item.assetTypeId = ele?.assetTypeInfo?.id;
					}

					return item;
				}) ?? [];
		}

		return newState;
	},
	getTotalPrice,
	getSubTotal,
	getTotalTax,
	getTotalDiscount,
};

export default config;
